import { render } from "./DudeImage.vue?vue&type=template&id=61909a7a&scoped=true&ts=true"
import script from "./DudeImage.vue?vue&type=script&lang=ts"
export * from "./DudeImage.vue?vue&type=script&lang=ts"

import "./DudeImage.vue?vue&type=style&index=0&id=61909a7a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61909a7a"]])

export default __exports__